import { HistoryPanelPromotionsDocument } from 'generated/resources/graphql'

import { useLazyQuery } from 'modules/core/hooks/useQuery'

type FetchPromotionsParams = {
  contractVersionIds: string[]
  itemsPerPage: number
  lastCursor?: string
}

export const usePromotions = () => {
  const [fetchPromotions, { data, loading, error }] = useLazyQuery(HistoryPanelPromotionsDocument)

  const fetch = ({ contractVersionIds, itemsPerPage, lastCursor }: FetchPromotionsParams) => {
    fetchPromotions({
      variables: {
        contractVersionIds,
        itemsPerPage,
        after: lastCursor,
      },
    })
  }

  return {
    fetch,
    data,
    loading,
    error,
  }
}
